module.exports = "../../blazor-traffic.JPG";